import {debounce, put, select} from 'redux-saga/effects'

import * as mobileMenuActions from '../actions/mobileMenu'
import * as paneActions from '../actions/pane'
import * as paneSelectors from '../store/pane'

export function* viewportUpdateWorker() {
  const windowIsDesktop = yield select(paneSelectors.windowIsDesktop)
  if (windowIsDesktop) {
    yield put(mobileMenuActions.closeMobileMenu())
  }
}

export function* viewportUpdateSaga() {
  yield debounce(200, paneActions.UPDATE_VIEWPORT, viewportUpdateWorker)
}
